import '../../App.css';
import WalletCard from  '../WalletCard/WalletCard.jsx';
import SectorAllocation from '../SectorAllocation.jsx';
import DailyInsight from '../../components/DailyInsight.jsx';
import WeeklyCoach from '../../components/WeeklyCoach.jsx';
import Transactions from '../Transactions/Transactions.jsx';
import MattiasAgeTracker from '../MattiasAgeTracker /MattiasAgeTracker .jsx';
import CryptoKPI from '../CryptoKPI.jsx';
import DividenKPI from '../DividenKPI.jsx';
import PortfolioValueKPI from '../PortfolioValueKPI.jsx';
import PortfolioYieldKPI from '../PortfolioYieldKPI.jsx';
import PortfolioGrowthChart from '../PortfolioGrowthChart.jsx';
import MonthlyDividendsChart from '../MonthlyDividendsChart.jsx';
import { Heading, Box } from '@chakra-ui/react';
import Page from '../UI/Page.jsx';
import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import proxy from '../../proxy';

// Configurația wallet-urilor afișate pe home (adresele rămân sursa de adevăr aici)
const WALLETS = [
  { name: "Litecoin",     address: "ltc1qt6tjlz3x0rhdsyvc96rvesk5ynlumn29ulgnr6", qrCode: "ltc",  code: "LTC",  logo: "ltclogo",  explorer: "litecoin",     symbol: "ltc" },
  { name: "Zcash",        address: "t1XzbCqLjjZb6H9NRYg8XTDAAVsWajcBG2Z",        qrCode: "zec",  code: "ZEC",  logo: "zeclogo",  explorer: "zcash",        symbol: "zec" },
  { name: "Doge",         address: "DLjbE1thbghL9MJbfEve3roAvBVQcejPRt",         qrCode: "doge", code: "DOGE", logo: "dogelogo", explorer: "dogecoin",     symbol: "doge" },
  { name: "Bitcoin Cash", address: "qpngrxn4a3nv8rzvceu8x3k2kczcv6hpcspxkrp6qf", qrCode: "bch",  code: "BCH",  logo: "bchlogo",  explorer: "bitcoin-cash", symbol: "bch" },
  { name: "Dash",         address: "XmYVV1G5A1owwzCFkYBwjDrmGnpGbHWANQ",         qrCode: "dash", code: "DASH", logo: "dashlogo", explorer: "dash",         symbol: "dash" },
  { name: "Polygon",      address: "0x37FECd8E8D9DC576851903c5a99709f3e0A42357", qrCode: "pol",  code: "POL",  logo: "pollogo",  explorer: "pol",          symbol: "pol" },
];

const Home = () => {
  // Un singur fetch pentru toate wallet-urile, mapate pe adresă
  const [walletsByAddress, setWalletsByAddress] = useState({});
  const [walletsLoading, setWalletsLoading] = useState(true);
  const [walletsError, setWalletsError] = useState(null);

  useEffect(() => {
    axios
      .get(`${proxy}server_mts/GetWallets.php?t=${Date.now()}`, {
        headers: { "Cache-Control": "no-cache" },
      })
      .then((res) => {
        const map = {};
        if (Array.isArray(res.data)) {
          res.data.forEach((w) => {
            if (w?.address) map[w.address] = w;
          });
        }
        setWalletsByAddress(map);
      })
      .catch(() => setWalletsError("Unable to retrieve balance."))
      .finally(() => setWalletsLoading(false));
  }, []);

  // Cardurile ordonate după valoarea în USD (amount × preț), descrescător
  const orderedWallets = useMemo(() => {
    const valueOf = (address) => {
      const w = walletsByAddress[address];
      return w ? Number(w.amount || 0) * Number(w.price || 0) : 0;
    };
    return [...WALLETS].sort((a, b) => valueOf(b.address) - valueOf(a.address));
  }, [walletsByAddress]);

  // Totalurile crypto se calculează din aceleași date (fără request separat la GetCryptoKpi)
  const cryptoTotals = useMemo(() => {
    let total = 0;
    let total24h = 0;
    Object.values(walletsByAddress).forEach((w) => {
      const amount = Number(w.amount || 0);
      total += amount * Number(w.price || 0);
      if (w.price_24h != null) total24h += amount * Number(w.price_24h);
    });
    return { total, total24h };
  }, [walletsByAddress]);

  return (
    <Page className="app">
      <div className="hero">
        <div className="hero-content">
          <MattiasAgeTracker/>
        </div>

        <div className="hero-content">
          <PortfolioValueKPI/>
        </div>

        <div className="hero-content">
          <DividenKPI/>
        </div>

        <div className="hero-content">
          <PortfolioYieldKPI/>
        </div>

        <div className="hero-content">
          <MonthlyDividendsChart/>
        </div>

        <div className="hero-content">
          <SectorAllocation/>
        </div>

        <div className="hero-content">
          <PortfolioGrowthChart/>
        </div>

        <div className="hero-content">
          <DailyInsight />
        </div>

        <div className="hero-content">
          <WeeklyCoach />
        </div>

        <div className="hero-content">
          <Box textAlign="center">
            <Heading fontSize="xl !important" color="teal.300">
              📊 Portfolio Crypto
            </Heading>
            <Box h="2px" w="50px" bg="teal.300" mx="auto" mt={2} borderRadius="full" />
          </Box>
        </div>

        <div className="hero-content">
          <CryptoKPI
            totalWallet={cryptoTotals.total}
            totalWallet24h={cryptoTotals.total24h}
            isLoading={walletsLoading}
            error={walletsError}
          />
        </div>

        <div className="hero-content">
          <main className="wallet-section">
            <div className="wallets">
              {orderedWallets.map((w) => (
                <WalletCard
                  key={w.address}
                  {...w}
                  wallet={walletsByAddress[w.address] || null}
                  loading={walletsLoading}
                  error={
                    !walletsLoading &&
                    (walletsError ||
                      (!walletsByAddress[w.address]
                        ? "Unable to retrieve balance."
                        : null))
                  }
                />
              ))}
            </div>
          </main>
        </div>

        <div className="hero-content">
          <Transactions/>
        </div>
      </div>
    </Page>
  )
}

export default Home
